import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useSaveEmailFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.emailsSaveFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.emailsFilters]);
    },
  });
};
